"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProfileEmploymentInfoCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Field_1 = __importDefault(require("../components/Field"));
const Loading_1 = __importDefault(require("../components/Loading"));
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const react_i18next_1 = require("react-i18next");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function ProfileEmploymentInfoCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [employmentInfo, setEmploymentInfo] = react_1.default.useState({
        jobTitle: "",
        hireDate: "",
        originalHireDate: "",
        payRate: "",
        annualSalary: "",
    });
    let displayFields = [
        "jobTitle",
        "hireDate",
        "originalHireDate"
    ];
    if (!props.hidePay)
        displayFields.push("payRate", "annualSalary");
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus("loading");
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => {
            MyProfile_1.default.getEmploymentInfo(token, props.employeeId).then((data) => {
                setEmploymentInfo(data);
                setStatus("done");
            })
                .catch((e) => { throw e; });
        }).catch((e) => {
            setEmploymentInfo(null);
            setStatus("error");
        }));
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    const renderDisplayFields = ({ item }) => {
        switch (item) {
            case "jobTitle":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:labels.job'), value: employmentInfo.jobTitle }));
            case "hireDate":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:labels.hired'), value: employmentInfo.hireDate }));
            case "originalHireDate":
                if (employmentInfo.originalHireDate != employmentInfo.hireDate) {
                    return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:labels.ogHired'), value: employmentInfo.originalHireDate }));
                }
                else {
                    break;
                }
            case "payRate":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:labels.hourly'), value: employmentInfo.payRate }));
            case "annualSalary":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:labels.salary'), value: employmentInfo.annualSalary }));
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('profile:text.employInfo'), style: { marginBottom: 8 } }), (status == "done" && ((0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: (0, jsx_runtime_1.jsx)(MasonryList_1.default, { columns: 2, data: displayFields, renderItem: renderDisplayFields, style: { marginVertical: 0, marginHorizontal: 0 } }) }))) || ((0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == "loading", error: status == "error", onRetry: () => refresh() }))] }));
}
